/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

window.Class = (function() {
	let subclass = function() {};

	let create = function(...args) {
		let parent = null;
		let properties = args;

		let klass = function(...args) {
			this.initialize.apply(this, args);
		};

		if (typeof properties[0] === "function") {
			parent = properties.shift();
		}

		const methods = Class.Methods;
		Object.keys(methods).forEach((key) => {
			klass[key] = methods[key];
		});

		klass.superclass = parent;
		klass.subclasses = [];

		if (parent) {
			subclass.prototype = parent.prototype;
			klass.prototype = new subclass();
			parent.subclasses.push(klass);
		}

		for (let property of properties) {
			klass.addMethods(property);
		}

		if (!klass.prototype.initialize) {
			klass.prototype.initialize = function() {};
		}

		klass.prototype.constructor = klass;

		return klass;
	};

	let addMethods = function(source) {
		let ancestor = this.superclass && this.superclass.prototype;
		let properties = Object.keys(source);
		let { length } = properties;

		for (let property of properties) {
			let value = source[property];

			if (
				ancestor &&
				typeof value === "function" &&
				value.argumentNames()[0] === "$super"
			) {
				let method = value;
				value = (m =>
					function() {
						return ancestor[m].apply(this, args);
					})(property).wrap(method);

				value.valueOf = (method => () => method.valueOf.call(method))(method);

				value.toString = (method => () => method.toString.call(method))(method);
			}

			this.prototype[property] = value;
		}

		return this;
	};

	return {
		create,

		Methods: {
			addMethods,
		},
	};
})();

String.prototype.capitalize = function() {
	return this.charAt(0).toUpperCase() + this.substring(1).toLowerCase();
};

String.prototype.stripTags = function() {
	return this.replace(/<\w+(\s+("[^"]*"|'[^']*'|[^>])+)?>|<\/\w+>/gi, "");
};

String.prototype.unescapeHTML = function() {
	return this.stripTags()
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&");
};

Array.prototype.first = function() {
	return this[0];
};

Array.prototype.last = function() {
	return this[this.length - 1];
};



// WEBPACK FOOTER //
// ./src/legacy/prototypeshim.js